import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { AlertTriangle, CheckCircle2, Info, XOctagon } from 'lucide-react';

const ToastContext = createContext(null);
export const useToast = () => useContext(ToastContext);
const ICON = { crit: XOctagon, warn: AlertTriangle, ok: CheckCircle2, info: Info };
const COLOR = { crit: 'var(--crit)', warn: 'var(--warn)', ok: 'var(--ok)', info: 'var(--info)' };

export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);
  const dismiss = useCallback((id) => setItems((l) => l.filter((t) => t.id !== id)), []);
  const push = useCallback((t) => {
    const id = `${Date.now()}-${Math.random()}`;
    setItems((l) => [...l.slice(-3), { id, tone: 'info', ...t }]);
    setTimeout(() => dismiss(id), t.duration || 6500);
  }, [dismiss]);
  const value = useMemo(() => ({ push }), [push]);
  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toasts" role="status" aria-live="polite">
        {items.map((t) => {
          const I = ICON[t.tone] || Info;
          return (
            <div key={t.id} className={`toast ${t.tone}`} onClick={() => dismiss(t.id)}>
              <I size={20} color={COLOR[t.tone]} style={{ flex: 'none', marginTop: 1 }} />
              <div><b>{t.title}</b>{t.text && <p>{t.text}</p>}</div>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}
